<template>
  <el-dialog
    title="审核不通过"
    :visible="true"
    :close-on-click-modal="false"
    width="422"
    :before-close="() => $emit('close')"
  >
    <span>
      <el-form
        ref="form"
        :model="formInline"
        class="demo-form-inline"
        :rules="rules"
      >
        <el-form-item label="" style="width: 100%;height: 116px" prop="remark">
          <el-input
            type="textarea"
            :rows="10"
            placeholder="请输入批注（您可以点击下方内容进行快捷回复）"
            v-model="formInline.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="background:#FFFFFF;color:#888888;padding-top: 120px">
        <div :span="24" style="color:#333333">
          请选择快捷批注内容
        </div>
        <div
          style="height: 27px;line-height: 27px"
          @click="formInline.remark = '图片不清晰'"
        >
          1.图片不清晰
        </div>
        <div
          style="height: 27px;line-height: 27px"
          @click="formInline.remark = '定位地点错误'"
        >
          2.定位地点错误
        </div>
        <div
          style="height: 27px;line-height: 27px"
          @click="formInline.remark = '不符合任务要求'"
        >
          3.不符合任务要求
        </div>
      </div>
    </span>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex;justify-content: center"
    >
      <el-button @click="() => $emit('close')">取 消</el-button>
      <el-button type="primary" @click="confirm">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'rejectDialog',
  data() {
    return {
      formInline: {
        remark: ''
      },
      rules: {
        remark: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (value.length > 200) {
                callback(new Error('批注内容不得超过200个字符。。。'));
              } else {
                callback();
              }
            }
          }
        ]
      }
    };
  },
  methods: {
    async confirm() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        this.$emit('confirm', this.formInline.remark);
      }
      this.$emit('confirm', this.formInline.remark);
    }
  }
};
</script>

<style scoped>
::v-deep .el-dialog__title {
  text-align: center;
}
</style>
